import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const taskWidths = ["75%", "90%", "60%", "85%"];

export const TaskListSkeleton = () => {
  return (
    <Card className="bg-card">
      <CardHeader className="py-0 pt-2 pr-2">
        <div className="flex justify-between items-center">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      </CardHeader>
      <CardContent className="pb-0 px-0">
        <div className="w-full flex justify-start pl-4 gap-4 py-2">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-12" />
        </div>
        <ul className="px-0">
          {[1, 2, 3, 4].map((i) => (
            <li key={i} className="flex items-center justify-between px-4 py-1">
              <div className="flex items-center gap-2 flex-1">
                <Skeleton className="h-5 w-5 rounded-full" />
                <Skeleton className="h-4" style={{ width: taskWidths[i - 1] }} />
              </div>
              <Skeleton className="h-4 w-4" />
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

